// composables/useMessageHistory.js
import { ref } from 'vue';
import { MESSAGE_TYPE_USER } from "@/constants";

export function useMessageHistory(chatStore, userInput, adjustRows) {
    const messageHistoryIndex = ref(-1);
    const userMessages = ref([]);
    const isViewingHistory = ref(true);
    const updateUserMessages = () => {
        userMessages.value = chatStore.messages
            .filter(msg => msg.type === MESSAGE_TYPE_USER)
            .map(msg => msg.text)
            .reverse();
    };
    const navigateUp = () => {
        if (!isViewingHistory.value) {
            return;
        }
        updateUserMessages();
        if (userMessages.value.length > 0) {
            messageHistoryIndex.value = (messageHistoryIndex.value + 1) % userMessages.value.length;
            userInput.inputValue = userMessages.value[messageHistoryIndex.value];
            adjustRows();
        }
    };
    const navigateDown = () => {
        if (!isViewingHistory.value) {
            return;
        }
        if (messageHistoryIndex.value > 0) {
            // eslint-disable-next-line no-plusplus
            messageHistoryIndex.value--;
            userInput.inputValue = userMessages.value[messageHistoryIndex.value];
        } else {
            messageHistoryIndex.value = -1;
            userInput.inputValue = '';
        }
        adjustRows();
    };
    const exitHistoryView = () => {
        isViewingHistory.value = false;
    };
    const resetHistoryView = () => {
        isViewingHistory.value = true;
    };
    return {
        isViewingHistory,
        navigateUp,
        navigateDown,
        exitHistoryView,
        resetHistoryView
    };
}